export const toTrimmedString = (str: string, maxChars = 20) => {
  if (str.length <= maxChars) {
    return str;
  }
  return `${str.substring(0, maxChars)}${str.length > maxChars ? "..." : ""}`;
};
